import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Footer from '../components/sections/Footer';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TermsAndConditions = () => {
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';
  const [data, setData] = useState({});

  useEffect(() => {
    axios.get(`${API}/admin/settings/terms_conditions`).then(r => {
      if (r.data?.value) setData(r.data.value);
    }).catch(() => {});
  }, []);

  const html = isZh ? (data.html_zh || data.html || '') : (data.html_en || data.html || '');

  return (
    <div className="min-h-screen bg-white flex flex-col pt-20">
      <main className="flex-grow py-12">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">{isZh ? '使用条款' : 'TERMS OF USE'}</h1>
          <div className="prose prose-gray max-w-none" dangerouslySetInnerHTML={{ __html: html }} data-testid="terms-conditions-content" />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
